import { useRef } from 'react';
import { cx } from './cx';
import styles from './Tabs.module.css';

/**
 * Reiter zum Umschalten innerhalb eines Bereichs. Auf schmalen Bildschirmen seitlich wischbar.
 * @param {{value:string,label:string,icon?:import('react').ComponentType,count?:number}[]} items
 */
export function Tabs({ items, value, onChange, label = 'Bereiche', className }) {
  const listRef = useRef(null);

  const focusTab = (index) => {
    const next = items[(index + items.length) % items.length];
    onChange(next.value);
    listRef.current?.querySelector(`[data-value="${CSS.escape(next.value)}"]`)?.focus();
  };

  const onKeyDown = (e) => {
    const index = items.findIndex((item) => item.value === value);
    if (e.key === 'ArrowRight') { e.preventDefault(); focusTab(index + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); focusTab(index - 1); }
    else if (e.key === 'Home') { e.preventDefault(); focusTab(0); }
    else if (e.key === 'End') { e.preventDefault(); focusTab(items.length - 1); }
  };

  return (
    <div ref={listRef} role="tablist" aria-label={label} className={cx(styles.tabs, className)} onKeyDown={onKeyDown}>
      {items.map(({ value: itemValue, label: itemLabel, icon: Icon, count }) => {
        const selected = itemValue === value;
        return (
          <button
            key={itemValue}
            type="button"
            role="tab"
            data-value={itemValue}
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            className={cx(styles.tab, selected && styles.selected)}
            onClick={() => onChange(itemValue)}
          >
            {Icon && <Icon aria-hidden />}
            <span>{itemLabel}</span>
            {count != null && <span className={styles.count}>{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
